import React, { useEffect } from 'react';

import { useAuth } from '../providers';
import { Loading } from './loading.component';

export function SigninCallback(): JSX.Element {
  const auth = useAuth();

  useEffect(() => {
    auth.signinRedirectCallback();
  }, []);

  return <Loading />;
}
